module.exports = __webpack_public_path__ + "53036e0dcecd6248893f4367e09be088.fbx";